<template>
    <th :class="[$style['mds-th'], classObject]" :aria-sort="ariaSort" scope="col">
        <div v-if="hasDefaultSlot" :class="$style['mds-th__inner']">
            <template v-if="sortable">
                <button :class="$style['mds-th__button']" @click="emitSortFieldChange($event)" type="button">
                    <slot />
                </button>
            </template>
            <span :class="$style['mds-th__text']" v-else>
                <slot />
            </span>
            <span v-if="hasActionSlot" :class="[$style['mds-th__action']]">
                <slot name="mds-th-actions" />
            </span>
        </div>
    </th>
</template>

<script>
    export default {
        name: 'MdsTh',
        props: {
            rightAligned: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, right aligns the cell text.',
                },
            },
            sortable: {
                type: Boolean,
                default: false,
                docs: {
                    validation: '—',
                    description: 'If `true`, allows table to sort when header item clicked.',
                },
            },
            sorted: {
                type: Number,
                default: 0,
                validator(value) {
                    return [-1, 0, 1].indexOf(value) !== -1;
                },
                docs: {
                    validation: 'One of: `-1`, `0`, `1`.',
                    description:
                        'Sets the default sorted column (-1: descending, 0: none, 1: ascending) and defines the sort order for that column. `sortable` must be true.',
                },
            },
        },
        computed: {
            classObject() {
                const obj = {};
                obj[this.$style['mds-th--sorted-ascending']] = this.sortable && this.sorted === 1;
                obj[this.$style['mds-th--sorted-descending']] = this.sortable && this.sorted === -1;
                obj[this.$style['mds-th--right']] = this.rightAligned;
                obj[this.$style['mds-th--sortable']] = this.sortable;

                return obj;
            },
            hasDefaultSlot() {
                return !!this.$slots.default;
            },
            hasActionSlot() {
                return !!this.$slots['mds-th-actions'];
            },
            ariaSort() {
                const ariaSort = {
                    '-1': 'descending',
                    '0': 'none',
                    '1': 'ascending',
                };

                return ariaSort[`${this.sorted}`];
            },
        },
        methods: {
            emitSortFieldChange($event) {
                this.$emit('mds-th-sort-changed', $event);
            },
        },
    };
</script>

<style lang="scss" module>
    @import './th.scss';
</style>
